import { Vue, Component } from 'vue-property-decorator';
import template from './insights-loading-indicator.vue';

@Component({
  mixins: [template],
})
export default class InsightsLoadingIndicator extends Vue {
  
}
